import React from "react";
import CategoryText from "./category-text";
import { Link } from "gatsby";
import ShareSocial from "./share-social";
import "@fontsource/roboto/100.css";

function TagButton({ children, target, className = "" }) {
  return (
    <Link
      to={`/destinations/?f=${encodeURI(target)}`}
      className={`bg-secondary-light px-6 flex flex-col justify-center ${className}`}
    >
      <CategoryText className="text-center align-middle text-primary uppercase font-thin">
        {children}
      </CategoryText>
    </Link>
  );
}

export default function TagButtonStrip({
  className,
  categories = [],
  title,
  cover,
  description,
  slug,
}) {
  const names = [...new Set(categories)].sort();
  return (
    <div className="flex flex-wrap uppercase justify-start my-6 -mx-1">
      <div />
      {names.map((displayName) => (
        <TagButton key={displayName} target={displayName} className="m-1">
          {displayName}
        </TagButton>
      ))}

      <ShareSocial
        className="flex-grow justify-end"
        iconClassName="text-3xl"
        title={title}
        cover={cover}
        description={description}
        slug={slug}
      ></ShareSocial>
    </div>
  );
}
